<template>
    <Alert v-if="alertContent || loadingMood" :loadingMood="loadingMood" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=''"/>
    <div id="user-panel">
        <div class="container-size-fixer row" id="main-content-box">
            <div class="dashboard-box col-2">
                <div id="dashboard-navigation">
                    <ul>
                        <li v-on:click="$router.push('/user-panel')"  :class="[{ isActive: $route.name=='UserHome' }, '']">
                            <img class="normal-icon" width="20" height="20" src="../assets/appIcons/Panel/normal-icon/Dashboard.png" alt="">
                            <img class="pink-icon" width="20" height="20" src="../assets/appIcons/Panel/pink-icon/Dashboard.png" alt="">
                            داشبورد
                        </li>
                        <li v-on:click="$router.push('/user-panel/edit-personal-infos')" :class="[{ isActive: $route.name=='EditPersonalInfos' }, '']">
                            <img class="normal-icon" width="18" height="20" src="../assets/appIcons/Panel/normal-icon/Edit.png" alt="">
                            <img class="pink-icon" width="18" height="20" src="../assets/appIcons/Panel/pink-icon/Edit.png" alt="">
                            ویرایش اطلاعات
                        </li>
                        <li  v-on:click="$router.push('/user-panel/saved-articles')" :class="[{ isActive: $route.name=='SavedArticles' }, '']">
                            <img class="normal-icon" width="15" height="20" src="../assets/appIcons/Panel/normal-icon/Saved.png" alt="">
                            <img class="pink-icon" width="15" height="20" src="../assets/appIcons/Panel/pink-icon/Saved.png" alt="">
                            مقالات ذخیره شده
                        </li>

                        <li style="display: flex;align-items: center;"  v-on:click="$router.push('/user-panel/conversation-with-experts/chatting')" :class="[{ isActive: $route.name=='ConversationWithExperts' }, '']">
                            <img style="margin-left: 5px" class="normal-icon" width="20" height="20" src="../assets/appIcons/Panel/normal-icon/Chat.png" alt="">
                            <img style="margin-left: 5px" class="pink-icon" width="20" height="20" src="../assets/appIcons/Panel/pink-icon/Chat.png" alt="">

                            گفتگو
                            <span v-if="$store.state.notificationDetails.unreadMessagesCount > 0" class="new-messages-count">{{$store.state.notificationDetails.unreadMessagesCount}}</span>
                        </li>
                        <li  v-on:click="$router.push('/user-panel/user-bills')" :class="[{ isActive: $route.name=='UserBills' }, '']">
                            <img class="normal-icon" width="17" height="20" src="../assets/appIcons/Panel/normal-icon/Bills@1x.svg" alt="">
                            <img class="pink-icon" width="17" height="20" src="../assets/appIcons/Panel/pink-icon/Bills@1x.svg" alt="">
                            صورت حساب ها
                        </li>
                        <li  v-on:click="$router.push('/user-panel/user-documents')" :class="[{ isActive: $route.name=='UserDocuments' }, '']">
                            <img class="normal-icon" width="16" height="20" src="../assets/appIcons/Panel/normal-icon/Docs@1x.svg" alt="">
                            <img class="pink-icon" width="16" height="20" src="../assets/appIcons/Panel/pink-icon/Docs@1x.svg" alt="">
                            مدارک
                        </li>
                        <li  v-on:click="$router.push('/user-panel/advanced-search')" :class="[{ isActive: $route.name=='AdvancedSearch' }, '']">
                            <img class="normal-icon" width="20" height="20" src="../assets/appIcons/Panel/normal-icon/Search.png" alt="">
                            <img class="pink-icon" width="20" height="20" src="../assets/appIcons/Panel/pink-icon/Search.png" alt="">
                            جست و جوی پیشرفته
                        </li>
                    </ul>
                </div>
                <div id="dashboard-logout" v-on:click="$router.push('/user-panel/logout')" >
                    <img class="normal-icon" width="20" height="20" src="../assets/appIcons/Panel/normal-icon/Exit.png" alt="">
                    <img class="pink-icon" width="20" height="20" src="../assets/appIcons/Panel/pink-icon/Exit.png" alt="">
                    <span>
                        خروج
                    </span>
                </div>
                <div id="dashboard-expert" v-on:click="$router.push('/author-page/'+expertDetail.username)">
                    <div class="dashboard-expert-row">

                        <img v-if="expertDetail.file !== null" width="80"  height="80" :src="$store.state.base_urls.adminsUploads + expertDetail.file" alt="">
                        <img v-else width="80"  height="80" :src="require('../assets/defaults/man.jpg')" alt="">

                        <div class="expert-name">
                            {{expertDetail.name}}
                        </div>
                        <div class="expert-description">
                            کارشناس
                            <span v-for="(option , index) in expertDetail.options" :key="option">
                                <span v-if="index>0">
                                    و
                                </span>
                              {{option}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-10 col-md-12 col-sm-12" id="dashboard-container">
                <div id="router-view-box">
                    <router-view/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import Alert from "../components/Alert"
    import Pusher from 'pusher-js';
    export default {
        name: "UserPanel",
        data(){
            return {
                alertContent: null,
                loadingMood: false,
                expertDetail: {
                    id: null,
                    file: null,
                    name:null,
                    username:null,
                    options: [],
                    online_status:false
                },
                alongExpertDetail: {
                    id: null,
                    file: null,
                    name:null,
                    username:null,
                    options: [],
                    online_status:false,
                    interval:null,
                },
            }
        },
        components:{
            Alert
        },
        methods:{

            async getRelatedExpertDetail(){
                if(this.$route.name!=='Logout'){
                    try {
                        let response = await axios.get('api/userDashboard/expertDetail',{headers:{"Authorization" : `Bearer ${localStorage.getItem('token')}`}});
                        this.expertDetail=response.data.expertDetail;
                        this.$store.state.expertDetail =  this.expertDetail;
                        if(response.data.alongExpertDetail!=null){
                            this.alongExpertDetail=response.data.alongExpertDetail;
                            this.$store.state.alongExpertDetail = this.alongExpertDetail;
                        }
                        if(this.expertDetail){
                            let pusher = new Pusher('cbbfe2a7885f291a7196', {
                                cluster: 'eu'
                            });
                            let channel = pusher.subscribe(`change-admin-status.${this.expertDetail.unique_id}`);
                            channel.bind('change-admin-status', (data) => {
                                this.$store.state.expertDetail  = data.admin ;
                            });
                        }
                        if(this.alongExpertDetail){
                            let pusher = new Pusher('cbbfe2a7885f291a7196', {
                                cluster: 'eu'
                            });
                            let channel = pusher.subscribe(`change-admin-status.${this.alongExpertDetail.unique_id}`);
                            channel.bind('change-admin-status', (data) => {
                                this.$store.state.alongExpertDetail  = data.admin ;
                            });
                        }
                        //تایید کردن وضعیت آنلاین بودن و بررسی آنلاین بودن ادمین
                        const formData = {expert_id: this.expertDetail.id , alongExpert_id: this.alongExpertDetail.id};
                        axios.post('/api/userDashboard/verifyOnlineStatus',formData, {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        }).then(response => {
                            if(this.alongExpertDetail.id!=null){
                                this.$store.state.expertDetail.online_status =  response.data.expert_online_status;
                                this.$store.state.alongExpertDetail.online_status = response.data.alongExpert_online_status;
                            }else{
                                this.$store.state.expertDetail.online_status = response.data.expert_online_status;
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        setInterval(() => {
                            if(this.$store.state.loginStatus){
                                const formData = {expert_id: this.expertDetail.id , alongExpert_id: this.alongExpertDetail.id};
                                axios.post('/api/userDashboard/verifyOnlineStatus',formData, {
                                    headers:
                                        {
                                            "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                        }
                                }).then(response => {
                                    if(this.alongExpertDetail.id!=null){
                                        this.$store.state.expertDetail.online_status =  response.data.expert_online_status;
                                        this.$store.state.alongExpertDetail.online_status = response.data.alongExpert_online_status;
                                    }else{
                                        this.$store.state.expertDetail.online_status = response.data.expert_online_status;
                                    }
                                }).catch(error => {
                                    console.log(error);
                                });
                            }
                        }, 120000);
                        //تایید کردن وضعیت آنلاین بودن و بررسی آنلاین بودن ادمین
                    } catch (error) {
                        console.log(error)
                    }
                }
            },

        },
        created: function () {
            this.getRelatedExpertDetail();
    }
    }
</script>

<style lang="scss" scoped>
    .new-messages-count {
        color: red;
        position: absolute;
        right: 80px;
        width: 30px;
        height: 30px;
        background-color: beige;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #user-panel{
        /*overflow-x: hidden;*/
    }
    #router-view-box{
        position: relative;
        width: 100%;
        border-radius: 10px;
        border: solid 2px lightgray;
        background-color: #ffffff;
    }
    .expert-description{
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #1a1a1a;
    }
    .dashboard-expert-row{
        width: auto;
        img{
            border-radius: 50%
        }
    }
    .expert-name{
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
    }
    #dashboard-expert-row{
        div{
            width: 100%;
            text-align: center;
            height: 20px;
        }
        text-align: center;
    }
    #dashboard-expert{
        overflow-y: auto;
        cursor: pointer;
        width: 200px;
        height: 179px;
        padding: 15px 16px 20px 15px;
        border-radius: 10px;
        border: solid 2px lightgray;
        background-color: #ffffff;
        align-items: center;
        justify-content: center;
        margin: 10px auto 0 auto;
    }
    #dashboard-logout{
        display: inline-block;
        width: 200px;
        height: 45px;
        line-height: 45px;
        border-radius: 10px;
        border: solid 2px lightgray;
        background-color: #ffffff;
        margin-top: 10px;
        text-align: right;
        color: #162336;
        padding-right: 10px;
        span{
            opacity: 0.7;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
        }
    }
    #dashboard-container{
        /*padding-right: 20px;*/
        margin-left: auto;
        margin-right: auto;
        display: flex;
        align-items: stretch;
        max-width: 940px;
        width: 100%;
        top: 0;
        height: auto;
        padding: 0 15px 0 15px;
    }
    /*#main-container{*/
        /*height: 315px;*/
        /*width: 100%;*/
        /*border-radius: 10px;*/
        /*border: solid 2px lightgray;*/
        /*background-color: #ffffff;*/
    /*}*/
    .pink-icon{
        display: none;
    }
    #dashboard-navigation{
        overflow: hidden;
        ul{
            list-style-type: none;
            padding: 0;
            li{
                height: 45px;
                opacity: 0.7;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: right;
                color: #162336;
                padding: 11px 10px;
                cursor: pointer;
                transition: all 0.1s ease;

                &:hover{
                    background-color: rgba(254,240,239);
                    color: #fe7063;
                    .pink-icon{
                        display: inline-block;
                    }
                    .normal-icon{
                        display: none;
                    }
                }
            }
        }
        display: inline-block;
        width: 200px;
        height: 315px;
        border-radius: 10px;
        border: solid 2px lightgray;
        background-color: #ffffff;
    }
    #dashboard-logout:hover{
        cursor: pointer;
        background-color: rgba(254,240,239);
        color: #fe7063;
        .pink-icon{
            display: inline-block;
        }
        .normal-icon{
            display: none;
        }
    }
    .dashboard-box{
        padding: 0!important;
        display: inline-block;
    }
    #main-content-box{
        width: 100%;
        height: auto;
        /*background-color: #4285f4;*/
        /*display: flex;*/
        /*align-items: start;*/
        padding: 0!important;
    }
    #user-panel{
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f5f6fa;
        min-height: 500px;
        height: auto;
        padding-top: 50px;
        padding-bottom: 50px;
        position: relative;
        z-index: 0;
    }

    @media (max-width: 1300px) {
        .dashboard-box{
            display: none;
        }
    }
    .isActive{
        background-color: rgba(254,240,239);
        color: #fe7063!important;
        .pink-icon{
            display: inline-block;
        }
        .normal-icon{
            display: none;
        }
    }

</style>